/**
 * Quickshop
 */
if (!customElements.get('quickshop-wrapper')) {
  class QuickShopWrapper extends HTMLElement {
    constructor() {
      super();

      // Default options
      this.options = {
        popup: true,
        addToCart: true,
      };

      // Check the data-action attribute and set addToCart to false if it's not present
      if (this.dataset.action && this.dataset.action === 'atc') {
        this.options.addToCart = true;
      } else {
        this.options.addToCart = false;
      }

      // Get options from element data and combine with this.options
      if (this?.dataset?.options) {
        const dataOptions = JSON.parse(this.dataset.options);
        this.options = {
          ...this.options,
          ...dataOptions,
        };
      }

      //on click, console log the event
      this.addEventListener('click', (event) => {
        //find .icon-spinner and remove the hidden class, find .icon-add-to-cart and add the hidden class
        this.querySelector('.icon--spinner').classList.remove('hidden');
        this.querySelector('.icon--add-to-cart').classList.add('hidden');

        if (this.options.addToCart) {
          this.variantOptions = this.variantOptions || this.querySelectorAll('[data-option-group]');
          if (!this.variantOptions.length) {
            this.submit = this.submit || this.querySelector('[type="submit"]');
            this.submit.click();

            setTimeout(() => {
              this.querySelector('.icon--spinner').classList.add('hidden');
              this.querySelector('.icon--add-to-cart').classList.remove('hidden');
            }, 1000);
            return false;
          }
        } else if (this.dataset.redirurl) {
          window.location.href = this.dataset.redirurl;
        }
      });
    }
  }

  window.QuickShopWrapper = QuickShopWrapper;
  customElements.define('quickshop-wrapper', QuickShopWrapper);
}
